module.exports = __webpack_public_path__ + "img/search-icon.42f5d2af.svg";